import { render } from "./CardControls.vue?vue&type=template&id=9b7c7ec0"
import script from "./CardControls.vue?vue&type=script&lang=js"
export * from "./CardControls.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__